import getColour from '@lendi-ui/commons/colours';

import { FIELD_PATHS } from '@funnels/constants';
import { ProductPreferencesEntityIndex } from '@funnels/types';
import { Body } from '@funnels/ui-components';
import { validateInclusiveNumberRanges } from '@funnels/utils';

import { NumericalInputField } from '../../Fields';
import { FunnelViewProps } from '../types';

export interface ProductPreferencesLoanTermTeamViewProps extends FunnelViewProps, ProductPreferencesEntityIndex {}

export const ProductPreferencesLoanTermTeamView = (props: ProductPreferencesLoanTermTeamViewProps) => {
  const { productPreferencesIndex, isOptional } = props;

  return (
    <NumericalInputField
      name={FIELD_PATHS.PRODUCT_PREFERENCE_LOAN_TERM(productPreferencesIndex)}
      validate={validateInclusiveNumberRanges(
        5,
        40,
        isOptional,
        'Please enter between 5-40 years.',
        'Please enter the loan term.'
      )}
      helpText="Please enter between 5-40 years."
      maxLength={2}
      isOptional={isOptional}
      after={
        <Body color={getColour('text', 'subtle')} mr="xs" size="xs">
          YEARS
        </Body>
      }
    />
  );
};
